export default "__VITE_ASSET__Bxg59I4p__"